module.exports = __webpack_public_path__ + "img/99d8e0e.jpg";